import Seo from "../Seo";

/**
 * One legal document under the site's logo header.
 *
 * These pages are the only copy of the documents: the mobile app opens them
 * by URL (see PrivacyPolicyModal in the app), so editing texts.js updates the
 * website and every installed app at once.
 */
export default function PolicyPage({ html, title, description, path }) {
  return (
    <div className="privacy-root">
      <Seo title={title} description={description} path={path} />
      <header className="privacy-header">
        <img src="/assets/logo_transparent.png" alt="ThriveOn logo" />
        <h2>ThriveOn</h2>
      </header>
      <main className="policy-content-container">
        <div
          className="policy-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </main>
    </div>
  );
}
